"use client"
import { skills } from "@/lib/data"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import SkillBadge from "@/components/skill-badge"
import { Code, Cloud, Lightbulb, Brain, ShieldCheck } from "lucide-react"
import { motion } from "framer-motion"

const skillCategories = [
  { title: "Languages & Frameworks", icon: <Code className="h-6 w-6 text-primary" />, data: skills.languagesFrameworks },
  { title: "Data & AI", icon: <Brain className="h-6 w-6 text-primary" />, data: skills.dataAi },
  { title: "Cloud & Platforms", icon: <Cloud className="h-6 w-6 text-primary" />, data: skills.cloudPlatforms },
  { title: "Domain", icon: <ShieldCheck className="h-6 w-6 text-primary" />, data: skills.domain },
  { title: "Currently Learning", icon: <Lightbulb className="h-6 w-6 text-primary" />, data: skills.currentlyLearning },
]

export default function SkillsSection() {
  return (
    <section id="skills" className="section-padding">
      <div className="container">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="heading-responsive font-bold text-center mb-12 font-display"
        >
          Technical Stack & Skills
        </motion.h2>
        <div className="card-grid">
          {skillCategories.map((category, catIndex) => (
            <motion.div
              key={category.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.45, delay: catIndex * 0.06, ease: [0.22, 1, 0.36, 1] }}
            >
              <Card className="h-full border-2 border-transparent hover:border-primary/15 hover:shadow-lg transition-all duration-300 backdrop-blur-sm bg-background/80">
                <CardHeader>
                  <div className="flex items-center">
                    {category.icon}
                    <CardTitle className="ml-3 text-xl font-semibold">{category.title}</CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="flex flex-wrap gap-2">
                    {category.data.map((skill, index) => (
                      <SkillBadge
                        key={skill}
                        skill={skill}
                        index={index}
                        variant={category.title === "Currently Learning" ? "default" : "secondary"}
                        className={
                          // green-700/800 rather than 600/700: white on green-600
                          // is 3.30:1, below the WCAG AA 4.5:1 minimum. green-700
                          // gives 5.02:1 and the hover state 7.13:1.
                          category.title === "Currently Learning" ? "bg-green-700 hover:bg-green-800 text-white" : ""
                        }
                      />
                    ))}
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
